// © Microsoft Corporation. All rights reserved.
/**
 * Helper to create an error for logging with message and customMessage properties without having
 * to go manually clone the error object, or property bag, etc.
 * @param baseError - The base error object to use as prototype for creating the error
 * @param message - The custom message to use for the error
 * @param customMessage - The custom message that may contain strings that do not aggregate well (i.e., unique / per request data)
 */
export function createError(baseError, message, customMessage) {
    return Object.assign(Object.assign({}, baseError), { message: message || baseError.message, pb: customMessage
            ? Object.assign(Object.assign({}, baseError.pb), { customMessage }) : baseError.pb });
}
//# sourceMappingURL=AppErrorHelper.js.map